export default {
  validate (specificItemValue) {
    return {
      required: true,
      valid: specificItemValue && Number(specificItemValue) >= Number(this.constants.SPECIFIC_ITEM_VALUE_MIN) && Number(specificItemValue) <= Number(this.constants.SPECIFIC_ITEM_VALUE_MAX),
    };
  },
  message (fieldName, { _value_: specificItemValue }) {
    if (!specificItemValue) return 'Please give a value to this item.';
    if (Number(specificItemValue) < Number(this.constants.SPECIFIC_ITEM_VALUE_MIN) || Number(specificItemValue) > Number(this.constants.SPECIFIC_ITEM_VALUE_MAX)) return `Please enter a number between ${this.constants.SPECIFIC_ITEM_VALUE_MIN} and ${this.constants.SPECIFIC_ITEM_VALUE_MAX}.`;
  },
  computesRequired: true,
};
